import { useEffect } from "react";
import { useSelector } from "react-redux";

import { TABLE_TYPES } from "globals/constants/tableTypes";

import { loadActiveColumns, updateColumns } from "../services/columnsService";
import { loadTasksActiveColumns, setTasksActiveColumns } from "../store/actions/columns";

const selectors = {
	AWARD: state => state.columns.awards.activeColumns || [],
	PROPOSAL: state => state.columns.proposals.activeColumns || [],
	AWARD_MODIFICATION: state => state.columns.modifications.activeColumns || [],
	SUBAWARD: state => state.columns.subawards.activeColumns || [],
	SUBAWARD_MODIFICATION: state => state.columns.modifications.activeColumns || [],
	TASK: state => state.columns.tasks.activeColumns || [],
};

export const useActiveColumns = (type, formColumnHeaders) => {
	const columns = useSelector(selectors[type]);

	useEffect(() => {
		if ("TASK" === type) {
			loadTasksActiveColumns()();
		} else {
			const loadColumns = async () => {
				const headers = [ TABLE_TYPES.AWARD, TABLE_TYPES.PROPOSAL, TABLE_TYPES.SUBAWARD ].includes(type) ? formColumnHeaders : null;
				await loadActiveColumns(type, headers)();
			};
			loadColumns();
		}
	}, [ type, formColumnHeaders ]);

	const updateActiveColumns = async (newColumns, saveToDatabase = true) => {
		if ("TASK" === type) {
			await setTasksActiveColumns(newColumns);
		} else {
			const headers = [ "AWARD", "PROPOSAL", "SUBAWARDS" ].includes(type) ? formColumnHeaders : null;
			await updateColumns(newColumns, type, headers, saveToDatabase);
		}
	};

	return { columns, updateActiveColumns };
};
